import React, { useState, useEffect, useMemo } from "react";
import BackMethods from "../../back_component/BackMethods";
import img from "../../1.webp";
import { useNavigate, useSearchParams } from "react-router-dom";
import Select from "react-select";
export default function ViolationReportsPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { backEnd_request, getUserConstraints } = BackMethods();
  const { userGovernorate, userCity, isSuperAdmin } = getUserConstraints();

  // --- دالة للحصول على القيمة من الـ URL أو الـ SessionStorage أو الافتراضي ---
  const getInitialValue = (key, defaultValue) => {
    const urlValue = searchParams.get(key);
    if (urlValue !== null) return urlValue;

    const saved = sessionStorage.getItem("violation_filters_final");
    if (saved) {
      const parsed = JSON.parse(saved);
      return parsed[key] !== undefined ? parsed[key] : defaultValue;
    }
    return defaultValue;
  };

  // --- States ---
  const [reports, setReports] = useState([]);
  const [violationTypes, setViolationTypes] = useState([]);
  const [locationsData, setLocationsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(
    parseInt(getInitialValue("page", 1)),
  );
  const [pageSize, setPageSize] = useState(
    parseInt(getInitialValue("size", 12)),
  );
  const [viewMode, setViewMode] = useState(getInitialValue("view", "cards"));

  const [selectedGov, setSelectedGov] = useState(
    getInitialValue("gov", userGovernorate || ""),
  );
  const [selectedCity, setSelectedCity] = useState(
    getInitialValue("city", userCity || ""),
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    getInitialValue("dist", ""),
  );
  const [violationTypeId, setViolationTypeId] = useState(
    getInitialValue("vType", ""),
  );
  const [startDate, setStartDate] = useState(getInitialValue("from", ""));
  const [endDate, setEndDate] = useState(getInitialValue("to", ""));

  const [totalPages, setTotalPages] = useState(1);
  const [totalReports, setTotalReports] = useState(0);
  const [searchTrigger, setSearchTrigger] = useState(0);

  // تحديث الـ URL والـ SessionStorage
  useEffect(() => {
    const params = {
      page: currentPage,
      size: pageSize,
      view: viewMode,
      gov: selectedGov,
      city: selectedCity,
      dist: selectedDistrict,
      vType: violationTypeId,
      from: startDate,
      to: endDate,
    };
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== "" && v !== null),
    );
    setSearchParams(cleanParams, { replace: true });
    sessionStorage.setItem("violation_filters_final", JSON.stringify(params));
  }, [
    currentPage,
    pageSize,
    viewMode,
    selectedGov,
    selectedCity,
    selectedDistrict,
    violationTypeId,
    startDate,
    endDate,
  ]);

  // جلب المواقع وأنواع المخالفات
  useEffect(() => {
    const fetchData = async () => {
      const params = {
        size: 10000,
      };
      try {
        const [locRes, typeRes] = await Promise.all([
          backEnd_request.get("/Locations?includeInactive=false", { params }),

          backEnd_request.get("/ViolationTypes"),
        ]);
        setLocationsData(locRes.data.data || []);
        setViolationTypes(typeRes.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (!isSuperAdmin && userGovernorate) {
      setSelectedGov(userGovernorate);
      // console.log(userGovernorate)
    }
  }, [userGovernorate, isSuperAdmin]);

  const availableGovernorates = useMemo(
    () => [...new Set(locationsData.map((l) => l.governorate))],
    [locationsData],
  );
  const availableCities = useMemo(() => {
    if (!selectedGov) return [];
    return [
      ...new Set(
        locationsData
          .filter((l) => l.governorate === selectedGov)
          .map((l) => l.city),
      ),
    ];
  }, [locationsData, selectedGov]);
  const availableDistricts = useMemo(() => {
    if (!selectedCity) return [];
    return locationsData
      .filter((l) => l.governorate === selectedGov && l.city === selectedCity)
      .map((l) => l.sector);
  }, [locationsData, selectedGov, selectedCity]);

  const fetchReports = async () => {
    setIsLoading(true);
    try {
      const res = await backEnd_request.get("/ViolationReports/by-type", {
        params: {
          page: currentPage,
          size: pageSize,
          violationTypeId: violationTypeId,
          governorate: selectedGov,
          city: selectedCity,
          district: selectedDistrict,
          from: startDate,
          to: endDate,
        },
      });
      // console.log(res);
      if (res.data) {
        setReports(res.data.data || []);
        setTotalReports(res.data.total || 0);
        setTotalPages(Math.ceil((res.data.total || 0) / pageSize));
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, [currentPage, searchTrigger, pageSize]);

  const handleSearchClick = () => {
    setCurrentPage(1);
    setSearchTrigger((prev) => prev + 1);
  };

  const handlePageChange = (p) => {
    if (p < 1 || p > totalPages) return;
    setCurrentPage(p);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetFilters = () => {
    sessionStorage.removeItem("violation_filters_final");
    setSearchParams({});
    setStartDate("");
    setEndDate("");
    setViolationTypeId("");
    if (isSuperAdmin) setSelectedGov("");
    setSelectedCity("");
    setSelectedDistrict("");
    setPageSize(12);
    setCurrentPage(1);
    setSearchTrigger((prev) => prev + 1);
  };

  return (
    <div
      className="container py-4 min-vh-100"
      style={{
        backgroundColor: "#f4f7f6",
        direction: "rtl",
        textAlign: "right",
      }}
    >
      {/* Header & Filters Card */}
      <div className="card border-0 shadow-sm rounded-4 mb-4 overflow-hidden">
        <div className="card-body p-4 bg-white">
          <div className="row g-3 align-items-center">
            <div className="col-12 col-lg-3 text-center text-lg-end border-start">
              <h2 className="fw-bold text-danger mb-1">تقرير الضبوط</h2>
              <span className="badge bg-danger-subtle text-danger rounded-pill px-3 py-2 mb-2">
                إجمالي النتائج: {totalReports}
              </span>
              <button
                className="btn btn-link btn-sm text-decoration-none text-muted d-block w-100"
                onClick={resetFilters}
              >
                <i className="bi bi-arrow-counterclockwise"></i> إعادة تعيين
                الفلاتر
              </button>
            </div>

            <div className="col-12 col-lg-9">
              <div className="row g-2">
                <div className="col-md-3">
                  <label className="small text-muted mb-1">نوع المخالفة</label>
                  <Select
                    className="basic-single border shadow-sm rounded-2"
                    classNamePrefix="select"
                    isClearable={true}
                    isRtl={true}
                    isSearchable={true}
                    placeholder="ابحث عن نوع المخالفة..."
                    // تحويل البيانات لتناسب تنسيق react-select { value, label }
                    options={[
                      { value: "", label: "كل الأنواع" },
                      ...violationTypes.map((v) => ({
                        value: v.violationTypeId.toString(),
                        label: v.name,
                      })),
                    ]}
                    // تحديد القيمة المختارة حالياً
                    value={
                      violationTypeId
                        ? {
                            value: violationTypeId,
                            label: violationTypes.find(
                              (v) =>
                                v.violationTypeId.toString() ===
                                violationTypeId.toString(),
                            )?.name,
                          }
                        : { value: "", label: "كل الأنواع" }
                    }
                    // معالجة التغيير
                    onChange={(selectedOption) => {
                      setViolationTypeId(
                        selectedOption ? selectedOption.value : "",
                      );
                    }}
                    menuPortalTarget={document.body} // يخبر القائمة أن تفتح مباشرة داخل الـ body لتجاوز أي overflow
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: 0,
                        boxShadow: "none",
                        minHeight: "38px",
                      }),
                      // أضف هذا السطر لضمان ظهور القائمة فوق كل شيء
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label className="small text-muted mb-1">المحافظة</label>
                  <select
                    className="form-select border shadow-sm"
                    value={selectedGov}
                    disabled={!isSuperAdmin}
                    onChange={(e) => {
                      setSelectedGov(e.target.value);
                      setSelectedCity("");
                      setSelectedDistrict("");
                    }}
                  >
                    <option value="">اختر المحافظة</option>
                    {availableGovernorates.map((g) => (
                      <option key={g} value={g}>
                        {g}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="small text-muted mb-1">المدينة</label>
                  <select
                    className="form-select border shadow-sm"
                    value={selectedCity}
                    disabled={!selectedGov}
                    onChange={(e) => {
                      setSelectedCity(e.target.value);
                      setSelectedDistrict("");
                    }}
                  >
                    <option value="">اختر المدينة</option>
                    {availableCities.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="small text-muted mb-1">المنطقة</label>
                  <select
                    className="form-select border shadow-sm"
                    value={selectedDistrict}
                    disabled={!selectedCity}
                    onChange={(e) => setSelectedDistrict(e.target.value)}
                  >
                    <option value="">اختر المنطقة</option>
                    {availableDistricts.map((d) => (
                      <option key={d} value={d}>
                        {d}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <div className="input-group input-group-sm">
                    <span className="input-group-text bg-light border">
                      من تاريخ
                    </span>
                    <input
                      type="date"
                      className="form-control border shadow-sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="input-group input-group-sm">
                    <span className="input-group-text bg-light border">
                      إلى تاريخ
                    </span>
                    <input
                      type="date"
                      className="form-control border shadow-sm"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <button
                    className="btn btn-danger w-100 shadow-sm fw-bold"
                    onClick={handleSearchClick}
                  >
                    البحث <i className="bi bi-search me-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* View Mode Toggle */}
      <div className="d-flex justify-content-end mb-3 align-items-center gap-3">
        <div className="bg-white p-1 rounded-3 shadow-sm border d-inline-flex">
          <button
            className={`btn btn-sm rounded-2 px-3 ${viewMode === "cards" ? "btn-success" : "btn-light text-muted"}`}
            onClick={() => setViewMode("cards")}
          >
            <i className="bi bi-grid-fill me-1"></i> كروت
          </button>
          <button
            className={`btn btn-sm rounded-2 px-3 ${viewMode === "table" ? "btn-success" : "btn-light text-muted"}`}
            onClick={() => setViewMode("table")}
          >
            <i className="bi bi-list-task me-1"></i> جدول
          </button>
        </div>
      </div>

      {/* Results */}
      {isLoading ? (
        <div className="text-center py-5">
          <div className="spinner-grow text-danger" role="status"></div>
          <p className="mt-3 text-danger fw-bold">جاري تحميل الضبوط...</p>
        </div>
      ) : reports.length === 0 ? (
        <div className="text-center py-5 bg-white rounded-4 shadow-sm border">
          <i className="bi bi-megaphone text-muted display-1"></i>
          <h4 className="mt-3 text-danger">لا توجد ضبوط مطابقة!</h4>
          <p className="text-muted">حاول تغيير خيارات البحث أو الفلاتر.</p>
        </div>
      ) : (
        <div className="animate-fade-in">
          {viewMode === "cards" ? (
            <div className="row g-4">
              {reports.map((report) => (
                <div
                  key={report.violationReportId}
                  className="col-12 col-sm-6 col-xl-4"
                >
                  <div
                    className="card border-0 h-100 shadow-hover transition-all rounded-4 overflow-hidden"
                    onClick={() =>
                      navigate(
                        `/admin/violation-details?id=${report.violationReportId}`,
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <div className="position-relative">
                      <img
                        src={report.photos?.[0]?.photoUrl || img}
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                        alt="violation"
                      />
                      <div className="position-absolute top-0 start-0 m-2">
                        <span className="badge rounded-pill bg-danger shadow-sm">
                          ضبط #{report.reportNumber}
                        </span>
                      </div>
                      <div className="position-absolute bottom-0 end-0 m-2">
                        <span className="badge bg-light bg-opacity-75 rounded-pill small">
                          {report.dayName + " "}
                          {new Date(report.reportDate).toLocaleDateString(
                            "ar-EG",
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="card-body p-3">
                      <h6
                        className="fw-bold text-danger mb-1"
                        style={{ minHeight: "30px" }}
                      >
                        {report.violationType.name}
                      </h6>
                      <div className="small fw-bold text-black mb-1">
                        <i className="bi bi-shop me-1 text-dark"></i>{" "}
                        {report.establishment.name}
                      </div>
                      <div className="small text-muted mb-2">
                        <i className="bi bi-person-badge me-1"></i> المخالف:{" "}
                        {report.offenderName}
                      </div>
                      <hr className="my-2 opacity-25" />
                      {/* معلومات الموقع - تنسيق كارد الزيارات */}
                      <div className="bg-light p-2 rounded-3 border-end border-danger border-4">
                        <div className="small text-dark fw-bold">
                          <i className="bi bi-geo-alt-fill text-danger me-1"></i>
                          {report.governorate} - {report.city}
                        </div>
                        <div
                          className="text-muted extra-small mt-1"
                          style={{ fontSize: "0.75rem" }}
                        >
                          <i className="bi bi-geo me-1"></i> قطاع:{" "}
                          {report.district || "غير محددة"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
              <table className="table table-hover align-middle mb-0 text-center">
                <thead className="bg-light">
                  <tr>
                    <th>رقم الضبط</th>
                    <th>التاريخ</th>
                    <th>المخالفة</th>
                    <th>المنشأة</th>
                    <th>الموقع</th>
                    <th>الإجراء</th>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((r) => (
                    <tr
                      key={r.violationReportId}
                      onClick={() =>
                        navigate(
                          `/admin/violation-details?id=${r.violationReportId}`,
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <td className="fw-bold text-danger">#{r.reportNumber}</td>
                      <td>
                        {new Date(r.reportDate).toLocaleDateString("ar-SY")}
                      </td>
                      <td
                        className="small fw-bold"
                        style={{ maxWidth: "200px" }}
                      >
                        {r.violationType.name}
                      </td>
                      <td className="small">{r.establishment.name}</td>
                      <td>
                        {r.governorate} - {r.city}
                      </td>
                      <td>
                        <button className="btn btn-sm btn-outline-danger rounded-pill px-3">
                          عرض
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 bg-white p-3 rounded-4 shadow-sm border">
              {/* معلومات النتائج */}
              <div className="text-muted small mb-3 mb-md-0">
                عرض <strong>{reports.length}</strong> من إجمالي{" "}
                <strong>{totalReports}</strong> ضبط
              </div>

              {/* اختيار عدد العناصر في الصفحة */}
              <div className="d-flex align-items-center gap-2 border-start ps-3">
                <label className="extra-small text-muted mb-0">العناصر:</label>
                <select
                  className="form-select form-select-sm border-0 bg-light shadow-none"
                  style={{ width: "auto", cursor: "pointer" }}
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(parseInt(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value={12}>12</option>
                  <option value={21}>21</option>
                  <option value={30}>30</option>
                  <option value={42}>42</option>
                </select>
              </div>
              {/* أزرار الصفحات */}
              <nav>
                <ul className="pagination pagination-sm mb-0 gap-1">
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link rounded-3 border-0 shadow-sm"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      السابق
                    </button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(
                      (p) =>
                        p === 1 ||
                        p === totalPages ||
                        Math.abs(p - currentPage) <= 1,
                    )
                    .map((p, idx, arr) => (
                      <React.Fragment key={p}>
                        {idx > 0 && arr[idx - 1] !== p - 1 && (
                          <span className="mx-1 text-muted">...</span>
                        )}

                        <li
                          className={`page-item ${currentPage === p ? "active" : ""}`}
                        >
                          <button
                            className="page-link rounded-3 border-0 shadow-sm px-3"
                            onClick={() => handlePageChange(p)}
                          >
                            {p}
                          </button>
                        </li>
                      </React.Fragment>
                    ))}
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link rounded-3 border-0 shadow-sm"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      التالي
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
